"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentPayoutType = void 0;
var TournamentPayoutType;
(function (TournamentPayoutType) {
    /**
     * Payout type based on the player rank position (Last Winning Position)
     */
    TournamentPayoutType["RankPosition"] = "rank_position";
    /**
     * Payout type based on the player top percent (Threshold Percentage)
     */
    TournamentPayoutType["TopPercent"] = "top_percent";
})(TournamentPayoutType = exports.TournamentPayoutType || (exports.TournamentPayoutType = {}));
//# sourceMappingURL=tournament-payout-type.js.map